export const PRIVACY_TERMS_URL = "https://www.aurenenergia.com.br/normas-de-privacidade/";
export const INSTAGRAM_URL = "https://www.instagram.com/gudenergia/";
export const LINKEDIN_URL = "https://www.linkedin.com/company/gudenergia/";
export const YOUTUBE_URL = "";
